import Layout from './components/Layout';
import { InputTokenFormForTransfer } from './components/InputTokenFormForTransfer';
import { SignUpForm } from './components/SignUpForm';
import { AfterRegisterPage } from './components/AfterRegisterPage';
import { NotFound } from '@/components/Pages/Errors/NotFound';
import { useState } from 'react';
import { AlreadyRegisteredPage } from './components/AlreadyRegisterPage';
import { liffClient } from '@/lib/liffClient';
import { useEffect } from 'react';
import { AboutTranslation } from './components/AboutTranslation';
import { LoginPage } from '../login';
import liff from '@line/liff';
import { executeGet } from '@/client/rest';
import { FacilityResponseType } from '@/features/reservation/types/FacilityResponseType';

export enum PageName {
  AboutTranslation = 'ABOUT_TRANSLATION',
  SignUp = 'SIGN_UP',
  Token = 'TOKEN',
  AlreadyRegistered = 'ALREADY_REGISTERED',
  AfterRegister = 'AFTER_REGISTER',
  Invalid = 'INVAILD'
}
export enum PageSegment {
  Top = 'TOP',
  Registration = 'REGISTRATION',
  Login = 'LOGIN'
}

export function TransferSignUpPage(props: {}) {
  const [activePage, setActivePage] = useState(PageName.AboutTranslation);
  const [activeSegment, setActiveSegment] = useState(PageSegment.Top);
  const [accessToken, setAccessToken] = useState<string>('');
  const [username, setUsername] = useState<string>('');
  const [facilityName, setFacilityName] = useState<string>('');
  const facilityId: string = sessionStorage.getItem('fid') || '';

  useEffect(() => {
    // 非ログイン状態からの予約のフロー(セッションストレージにfidを保存)で
    // ログイン画面に来た際に、施設名を取得し表示するための処理
    const fetchFacility = async () => {
      try {
        const facilityList = await executeGet<FacilityResponseType>({
          apiName: 'medirecoWebApi',
          path: '/get-facility-list'
        });

        // facilityList から該当する施設を検索
        const facility = facilityList.facilities?.find((facility) => facility.id === facilityId);

        if (facility?.facility_name) {
          // 施設名を状態にセット
          setFacilityName(facility?.facility_name);
        }
      } catch (error) {
        console.error('施設情報の取得に失敗しました:', error);
      }
    };

    // facilityId が存在すればデータを取得
    if (facilityId) {
      fetchFacility();
    }
  }, [facilityId]);

  const handleUsernameSet = (username: string) => {
    setUsername(username);
  };

  useEffect(() => {
    // 1: LINEのアクセストークンを取得
    fetchLineAccessToken();
  });

  const fetchLineAccessToken = async () => {
    const LIFF_ID = import.meta.env.VITE_LIFF_ID_TRANSFER;

    try {
      await liffClient.initLiff({ liffId: LIFF_ID });
      // ログイン状態を確かめ、ログインしていなければログインする
      await liffClient.ready();
      const accessToken = await liff.getAccessToken();
      setAccessToken(accessToken || '');
      return;
    } catch (error) {
      console.error('LIFFで想定外のエラーが起こりました:', error);
    }
  };

  const SwitchPage = () => {
    if (activeSegment === PageSegment.Top) {
      switch (activePage) {
        case PageName.AboutTranslation:
          return (
            <Layout title={facilityName || ''} noMyPage={true}>
              <AboutTranslation setActivePage={setActivePage} setActiveSegment={setActiveSegment} />
            </Layout>
          );

        case PageName.SignUp:
          return (
            <Layout title={facilityName || 'お客様情報'} noMyPage={true}>
              <SignUpForm setActivePage={setActivePage} onUsernameSet={handleUsernameSet} accessToken={accessToken} />
            </Layout>
          );
        case PageName.Token:
          return (
            <Layout title={facilityName || 'お客様情報'} noMyPage={true}>
              <InputTokenFormForTransfer setActivePage={setActivePage} username={username} accessToken={accessToken} />
            </Layout>
          );
        case PageName.AfterRegister:
          return (
            <Layout title={facilityName || 'お客様情報'} noMyPage={true}>
              <AfterRegisterPage setActivePage={setActivePage} />
            </Layout>
          );
        case PageName.AlreadyRegistered:
          return (
            <Layout title={facilityName || 'お客様情報'} noMyPage={true}>
              <AlreadyRegisteredPage setActivePage={setActivePage} />
            </Layout>
          );
        default:
          return <NotFound />;
      }
    } else {
      return <LoginPage setActivePage={setActiveSegment} facilityName={facilityName} fromLine={true} />;
    }
  };
  return <SwitchPage />;
}
export default TransferSignUpPage;
